import React, { useState } from 'react';
import { Switch } from '../../../../../components/buttons';
import AsyncSelect from 'react-select/async';
import FilterAction from '../../../../../store/action/filter';

export default function (props) {
    const [ view, setView ] = useState(false);
    const [ filterInput, setFilterInput ] = useState("");

    const onOpenView = async () => {
        setView(!view);
        if (view === true) {
            setFilterInput("");
        }
    };

    const onChangeFilter = (e) => {
        setFilterInput(e.label);
        const parsedFilter = JSON.parse(e.value);
        const newFilter = {
            confirmedEndDate: parsedFilter.confirmed_end_date,
            confirmedStartDate: parsedFilter.confirmed_start_date,
            couriers: parsedFilter.courier_codes,
            courierServices: parsedFilter.courier_service_codes,
            createdEndDate: parsedFilter.created_end_date,
            createdStartDate: parsedFilter.created_start_date,
            id: parsedFilter.id,
            name: parsedFilter.name,
            status: parsedFilter.status,
            tags:parsedFilter.tags
        }
        props.onChange(newFilter)
    }

    const searchFilters = async (inputValue) => {
        let result;
        if (props.userId) {
            result = await FilterAction.searchAdmin(inputValue,props.userId);
        } else {
            result = await FilterAction.search(inputValue);
        }
        if (!result.success) return;
        const formattedResult = result.filters.reduce((r,i) => {
            r.push({label:i.name,value:JSON.stringify(i)}); return r;
        },[]);
        return formattedResult
    }

    const handleInputChange = (value) => {
        const inputValue = value.replace(/\W/g, '');
        setFilterInput(inputValue);
        return inputValue;
    };

    const promiseOptions = inputValue =>
        new Promise(resolve => {
            setTimeout(() => {
                resolve(searchFilters(inputValue));
            }, 1000);
    });
  

    return (
        <div className="border-bottom">
            <div className={`${view ? null : "filter-view"}`}>
                <div className="py-3 container">
                    <div 
                        className="pointer row justify-content-between px-4" 
                        onClick={() => onOpenView()}
                    >
                        Search filter tersimpan 
                    </div>
                </div>
            </div>
            {
                view ? 
                    <div className="bg-lighter p-4">
                        <AsyncSelect
                            onChange={e => onChangeFilter(e)}
                            loadOptions={promiseOptions}
                            defaultOptions
                            onInputChange={handleInputChange}
                            placeholder="Masukkan filter id atau nama filter Anda"
                        />
                    </div>
                    : 
                    null
            }
        </div>
    )
};